import type { GeoPoint } from "./useLocation";

/**
 * Posts a single location update to the gateway, attached to the active session.
 * Best-effort (never blocks the UI) — uses keepalive so it survives navigation.
 */
export async function postLocationUpdate(
  gatewayUrl: string,
  token: string,
  sessionResourceUrl: string,
  point: GeoPoint
) {
  // sessionResourceUrl looks like: https://gateway/whip/<slug>/<sessionId>
  const sessionId = sessionResourceUrl.split("/").pop();
  if (!sessionId) return;
  const url = `${gatewayUrl.replace(/\/$/, "")}/location/${encodeURIComponent(sessionId)}`;

  try {
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      keepalive: true,
      body: JSON.stringify({
        lat: point.lat,
        lon: point.lon,
        accuracyM: point.accuracyM,
        altitudeM: point.altitudeM,
        headingDeg: point.headingDeg,
        speedMps: point.speedMps,
        at: point.at,
      }),
    });
  } catch {
    // best-effort — gateway has the last known position from WHIP headers
  }
}
